<template>
  <section ref="heroRef" class="hero-section" :class="[{ 'hero-section--half': !!imageKey }, extraClass]">
    <div v-if="imageKey" class="banner-item" :style="{ height: carouselHeight }">
      <img v-if="secondaryImage" :src="secondaryImage" class="banner-img" alt="">
    </div>
    <el-carousel v-else-if="bannerList.length" :height="carouselHeight" :interval="5000" arrow="always"
      indicator-position="none">
      <el-carousel-item v-for="item in bannerList" :key="item.id">
        <div class="banner-item">
          <video v-if="isVideo(item.image)" :src="item.image" class="banner-video" autoplay muted loop playsinline />
          <img v-else :src="item.image" class="banner-img" :alt="item.title">
          <h2 v-if="item.title" class="banner-title">{{ item.title }}</h2>
        </div>
      </el-carousel-item>
    </el-carousel>
  </section>
</template>

<script>
import { getCarouselList } from '@/api/carousel'
import { getSecondaryImages } from '@/api/index'

const BANNER_MIN_HEIGHT = 240
const BANNER_MAX_HEIGHT = 801
const BANNER_ASPECT = 2.4

export default {
  name: 'BannerCarousel',
  props: {
    extraClass: {
      type: String,
      default: ''
    },
    imageKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bannerList: [],
      secondaryImage: '',
      carouselHeight: `${this.imageKey ? BANNER_MIN_HEIGHT / 2 : BANNER_MIN_HEIGHT}px`
    }
  },
  created() {
    if (this.imageKey) {
      this.fetchSecondaryImage()
    } else {
      this.fetchBannerList()
    }
  },
  mounted() {
    this.syncCarouselHeight()
    window.addEventListener('resize', this.syncCarouselHeight, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.syncCarouselHeight)
  },
  methods: {
    syncCarouselHeight() {
      const width = this.$refs.heroRef ? this.$refs.heroRef.clientWidth : window.innerWidth
      let height = Math.round(
        Math.min(BANNER_MAX_HEIGHT, Math.max(BANNER_MIN_HEIGHT, width / BANNER_ASPECT))
      )
      if (this.imageKey) {
        height = Math.round(height / 2)
      }
      this.carouselHeight = `${height}px`
    },
    isVideo(url) {
      if (!url) return false
      return /\.(mp4|webm|ogg|mov)$/i.test(url)
    },
    async fetchBannerList() {
      try {
        const res = await getCarouselList()
        this.bannerList = Array.isArray(res.data) ? res.data : []
        this.$nextTick(this.syncCarouselHeight)
      } catch (e) {
        this.bannerList = []
      }
    },
    async fetchSecondaryImage() {
      try {
        const res = await getSecondaryImages()
        const data = res.data || {}
        this.secondaryImage = data[this.imageKey] || ''
        this.$nextTick(this.syncCarouselHeight)
      } catch (e) {
        this.secondaryImage = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-section {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  line-height: 0;

  ::v-deep .el-carousel {
    overflow: hidden;
  }

  ::v-deep .el-carousel__container,
  ::v-deep .el-carousel__item {
    height: 100%;
  }

  .banner-item {
    position: relative;
    width: 100%;
    height: 100%;
    line-height: normal;
  }

  .banner-img,
  .banner-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .banner-title {
    position: absolute;
    top: 200px;
    left: 100px;
    right: 100px;
    z-index: 2;
    margin: 0;
    color: #fff;
    font-size: 3rem;
    font-weight: bold;
    line-height: 1.3;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
    pointer-events: none;
  }
}
</style>
